<template>

   <b-modal
      id="modal-financial-add"
      centered
      title="Aggiungi Finanziaria"
      title-class="text-primary-light"
      header-text-variant="primary-light"
      body-class="px-0"
      size="md"
      ok-only
      ok-title="Aggiungi"
      @ok="addFinancial"
      @hide="$emit('hide', $event)"
    >

        <template #default>
        
        <div class="p-2">
            <b-form-group label="Nome Finanziaria">
                <b-form-input v-model="financial_name"></b-form-input>
            </b-form-group>
        </div>

        </template>

    </b-modal>
    
</template>

<script>

import {BRow, BCol, BModal, BImg, BFormInput, BFormGroup} from 'bootstrap-vue';

import {Requests} from "@/api";

export default {

    components: {
        BRow,
        BCol,
        BModal,
        BImg,
        BFormInput,
        BFormGroup,
    },

    data: () => ({
        financial_name: '',
    }),

    methods: {
        open() {
            this.$bvModal.show('modal-financial-add');
        },

        async addFinancial() {
            this.loading = true;

            let request_data = new FormData();

            request_data.append('financial_name', this.financial_name);

            try {
                const response = await Requests.addFinancial(request_data);
                console.debug(response);
                this.$swal.fire({
                    title: 'Finanziaria Creata',
                    icon: 'success',
                    text: 'Finanziaria creata con successo!',
                    customClass: {
                        title: 'text-primary-light',
                        confirmButton: "btn btn-primary"
                    },
                })
            } catch(err) {
                console.debug(err);
            }

            this.loading = false;
        }
    }

}

</script>
